import { HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";

import { tap } from "rxjs/operators";

import { Context, REQUEST, RESPONSE } from "@hermes/core-app-core";

import { redirectResponse } from "@hermes/core-response-service";

import { LOGGER } from "@hermes/core-web-logger";

import { MISSING_FACET_CONTEXT } from "../constants/missing-facet-context.constant";

import { handleMissingFacetResponse } from "../helpers/facet/facet.helper";
import { UrlManagerService } from "../services/url-manager/url-manager.service";
import { Facet, GridType, initialFacet } from "../store/grid.store.model";

// eslint-disable-next-line rxjs-x/finnish
export const missingFacetsRedirectInterceptor: HttpInterceptorFn = (
    request,
    // eslint-disable-next-line rxjs-x/finnish
    next,
) => {
    const missingFacetContext = request.context.get(MISSING_FACET_CONTEXT);

    if (!missingFacetContext) {
        return next(request);
    }

    const serverRequest = inject(REQUEST);
    const serverResponse = inject(RESPONSE);
    const context = inject(Context);
    const logger = inject(LOGGER);
    const urlManagerService = inject(UrlManagerService);

    return next(request).pipe(
        tap((event) => {
            if (!(event instanceof HttpResponse)) {
                return;
            }

            const result = handleMissingFacetResponse(
                event.body,
                missingFacetContext,
            );

            if (!result) {
                return;
            }

            missingFacetContext.result = result;

            if (
                !result.isMissingFacet ||
                !context.isInServerMode() ||
                !serverRequest ||
                !serverResponse
            ) {
                return;
            }

            const uodatedFacet: Facet = {
                ...missingFacetContext.facet,
                combinedFacets: result.filteredValues,
            };

            const facetWithoutMissingFacet =
                missingFacetContext.currentRouteData.gridType === GridType.Facet
                    ? uodatedFacet
                    : initialFacet;

            const builtMissingFacetUrl = urlManagerService.buildUrl({
                fhParams: missingFacetContext.currentRouteData.urlParams,
                sort: missingFacetContext.currentRouteData.sortBy,
                facet: facetWithoutMissingFacet,
                searchTerm: missingFacetContext.currentRouteData.searchTerm,
            });

            const requestPath = serverRequest.url.split("?")[0];
            const queryPart = builtMissingFacetUrl.includes("?")
                ? builtMissingFacetUrl.slice(builtMissingFacetUrl.indexOf("?"))
                : "";

            logger.warn(
                `Redirect to grid after wrong facet parameter passed : ${requestPath}${queryPart}`,
            );

            redirectResponse({
                request: serverRequest,
                response: serverResponse,
                newPath: `${requestPath}${queryPart}`,
                statusCode: 302,
                forceCleanQueryParameters: true,
            });
        }),
    );
};
